






























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { ValidationProvider, extend } from "vee-validate";
import { regex } from "vee-validate/dist/rules";

extend("warrantyregex", {
  ...regex,
  message: "Proszę podać okres gwarancji"
});

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormWarranty extends Vue {
  @PropSync("data", { type: Number }) private syncedData!: number;
  @Prop() private id!: string;
}
